import { useCallback } from 'react';
import { useAppSelector } from '@Hooks/index';
import { currentMaterialRequest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';

import { MaterialRequisitionItemFormResponse } from '@Types/api/form';
import { FormikProps } from 'formik';
import ModalContent from './components/ModalContent';

interface MaterialModalContentProps {
  isEditMode: boolean;
  isDisableSaveButton: boolean;
  formik: FormikProps<MaterialRequisitionItemFormResponse>;
  onSave: (
    formikValues: MaterialRequisitionItemFormResponse,
    requisitionId: number,
    addAnotherItem?: boolean
  ) => void;
  onDisableSaveButton: (isDisable: boolean) => void;
}

const MaterialModalContent: React.FC<MaterialModalContentProps> = ({
  isEditMode,
  formik,
  onSave,
  isDisableSaveButton,
  onDisableSaveButton,
}) => {
  const currentMRequest = useAppSelector(currentMaterialRequest);

  const handleSaveMaterialItem = useCallback(() => {
    onSave(formik?.values, currentMRequest.requestId, true);
    if (formik.values.repeatForAll) {
      const savedValues = {
        actCode: formik.values.actCode,
        actId: formik.values.actId,
        resCode: formik.values.resCode,
        repeatForAll: formik.values.repeatForAll,
      };

      formik.resetForm();
      formik.setValues({
        ...formik.values,
        ...savedValues,
      });
    } else {
      formik.resetForm();
    }
  }, [formik?.values, currentMRequest.requestId]);

  return (
    <ModalContent
      onDisableSaveButton={onDisableSaveButton}
      isEditMode={isEditMode}
      isDisableSaveButton={isDisableSaveButton}
      formik={formik}
      handleSubmit={formik.handleSubmit}
      handleSaveMaterialItem={handleSaveMaterialItem}
    />
  );
};

export default MaterialModalContent;
